import TreeViewComponent from "@CubeComponents/html/TreeView";
import { Suspense, lazy, useMemo, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import FormflowsWrapper from "../../../../projects/pages/ProjectSettings/formFlowWrapper";

const Workflows = lazy(() => import("@Features/projects/pages/ProjectSettings/WorkflowsWrapper"));

function Settings({ projectId }: { projectId: string }) {
  const treeRef = useRef<any>(null);

  const [urlSearchParams] = useSearchParams();
  const tab = urlSearchParams.get("tab");
  const [selected, setSelected] = useState(tab || "formFlows");

  const dataSource = useMemo(
    () => [
      { id: "userAdministration", name: "User Administration", parentId: null },
      { id: "workflows", name: "Review Flows", parentId: "userAdministration" },
      { id: "formFlows", name: "Form Flows", parentId: "userAdministration" },
    ],
    [],
  );

  // Highlight the default selected row once the grid is ready
  const onReactGridCreated = () => {
    const dv = treeRef.current?.dataView;
    const grid = treeRef.current?.slickGrid;
    if (!dv || !grid) return;
    const idx = dv.getIdxById(selected);
    if (idx != null && idx >= 0) {
      grid.setSelectedRows([idx]);
    }
  };

  const handleClick = (e: any) => {
    const row = e.detail?.args?.row;
    if (row == null) return;
    const dv = treeRef.current?.dataView;
    const grid = treeRef.current?.slickGrid;
    if (!dv || !grid) return;
    const item = dv.getItem(row);
    if (!item || item.parentId === null) return; // skip parent nodes
    grid.setSelectedRows([row]);
    setSelected(item.id);
  };

  return (
    <div className="flex border-t border-system_colour_44 h-full w-full overflow-auto">
      <div className="flex-none w-56">
        <TreeViewComponent
          ref={treeRef}
          treeData={dataSource}
          columnId="name"
          identifierPropName="id"
          parentPropName="parentId"
          disableHeader
          height="100%"
          onClick={handleClick}
          onReactGridCreated={onReactGridCreated}
        />
      </div>
      <div className="overflow-auto w-full">
        {selected == "workflows" && (
          <Suspense>
            <Workflows projectId={projectId} />
          </Suspense>
        )}
        {selected == "formFlows" && (
          <Suspense>
            <FormflowsWrapper projectId={projectId} />
          </Suspense>
        )}
      </div>
    </div>
  );
}

export default Settings;
